import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useStandardItem } from './standard-item-provider';
import { formSchema } from '../../components/forms/equipment-association-schema';
import AssociationForm from '../../components/forms/equipment-association-form';
import { determineUpdatableFields } from '../../components/forms/association-specification-fields';

const StandardAssociationEdit = () => {
  const {
    equipmentAssociation,
    updateEquipmentAssociation,
    multipleOptions,
    standardItem,
  } = useStandardItem();
  const isStandardItemInBetweenBidPeriods =
    equipmentAssociation?.standardItem?.isStandardItemInBetweenBidPeriods;
  const isSINInContractYear = standardItem?.isStandardItemInContractYear;

  const {
    formState: { errors },
    control,
    handleSubmit,
    register,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    reValidateMode: 'onChange',
  });

  const onSubmit = (data) => {
    const { id, standardItemId, equipmentCodeId } = equipmentAssociation;
    const { program, ...rest } = data;
    const updatableFields = determineUpdatableFields(rest);
    updateEquipmentAssociation({
      variables: {
        id: Number(id),
        equipmentAssociation: {
          standardItemId,
          equipmentCodeId,
          ...updatableFields,
        },
      },
    });
  };

  return (
    <form id="equipment-code-edit-form" onSubmit={handleSubmit(onSubmit)}>
      <AssociationForm
        control={control}
        errors={errors}
        register={register}
        setValue={setValue}
        updateEquipmentCodeId={() => {}}
        equipmentCodeId="0"
        equipmentAssociation={equipmentAssociation}
        multipleOptions={multipleOptions}
        isStandardItemInBetweenBidPeriods={isStandardItemInBetweenBidPeriods}
        isSINInContractYear={isSINInContractYear}
      />
    </form>
  );
};

export default StandardAssociationEdit;
